/**
 * Generated invoice mocks — Step 22/23.
 *
 * Built from contract value + line items. The Invoice tab renders this
 * as a styled "PDF preview" component.
 */

const isoDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

export const INVOICES = {
  'demo-radios': null,
  'demo-furniture': null,

  'demo-streetlights': {
    invoiceNumber: 'INV-2026-0142',
    issuedAt: isoDaysAgo(0),
    dueAt: isoDaysAgo(-30),
    status: 'submitted', // submitted | pending | paid
    issuer: {
      name: '[AI]Quire Procurement Inc.',
      address: '215 Spadina Ave, Suite 400, Toronto, ON M5T 2C7',
      gstNumber: 'GST 851234567 RT0001',
      bankInfo: 'TD Canada Trust · Transit 12345 · Account 7890123',
    },
    billTo: {
      name: 'Public Services and Procurement Canada',
      attn: 'Marie Beaulieu, Contract Authority',
      address: '11 Laurier St, Place du Portage Phase III, Gatineau, QC K1A 0S5',
      contractNumber: 'EN578-23-0227',
    },
    lineItems: [
      { description: '150W LED streetlight luminaires with NEMA 7-pin smart controllers', qty: 1100, unitCad: 1132.00, lineTotal: 1245200.00 },
    ],
    subtotal: 1245200.00,
    gstHstPct: 13,
    gstHstAmount: 0, // government-billed, ITB exemption applied
    total: 1245200.00,
    notes: 'GST/HST waived per ITB exemption (federal contract). Net 30 from invoice date.',
  },
};
